// Import React
import React from "react";

// Import Spectacle Core tags
import { Heading, Slide } from "spectacle";

export default () => {
  return (
    <Slide>
      <Heading textSize={50}>Parte I</Heading>
      <Heading size={4} textColor="tertiary" fit>
        Pruebas Unitarias
      </Heading>
    </Slide>
  );
};



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/01-title.js